/**
 * HandLandmarkerの作成
 */
import {
  HandLandmarker, // 手の検出
  FilesetResolver // wasmファイルの読み込み
} from '@mediapipe/tasks-vision';

import { getAssetsPath } from '../../utils/getAssetsPath';
const assetsPath = getAssetsPath();

/**
 * ファイル読み込みの種類を設定
 */
const LOAD_TYPE: string = 'file'; // cdn or file

// CDNのURL
const CDN_URL = {
  wasm: "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm",
  landmarker: {
    pose: {
      lite: "https://storage.googleapis.com/mediapipe-models/pose_landmarker/pose_landmarker_lite/float16/1/pose_landmarker_lite.task",
    },
    face: "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task",
    hand: "https://storage.googleapis.com/mediapipe-models/hand_landmarker/hand_landmarker/float16/1/hand_landmarker.task",
  }
}

// FIleのPath
const FILE_PATH = {
  wasm: assetsPath + '/lib/mediapipe/wasm',
  landmarkerModelAssetPath: assetsPath + '/lib/mediapipe/hand_landmarker.task'
}

/**
 * HandLandmarkerの作成
 * @param landmarkerType
 * @param options
 * @returns
 */
export const createHandLandmarker = async () => {
  const cdnUrl = CDN_URL.landmarker.hand;
  const filePath = FILE_PATH.landmarkerModelAssetPath;

  const PATH = {
    wasm: LOAD_TYPE === 'cdn' ? CDN_URL.wasm : FILE_PATH.wasm,
    modelAssetPath: LOAD_TYPE === 'cdn' ? cdnUrl : filePath,
  }

  /**
   * HandLandmarker Options
   * https://ai.google.dev/edge/mediapipe/solutions/vision/hand_landmarker/web_js?hl=ja
   */
  const optionsHandLandmarker = {
    baseOptions: {
      modelAssetPath: PATH.modelAssetPath,
      delegate: "GPU"
    },
    runningMode: "VIDEO", // タスクの実行モードを設定: VIDEO or IMAGE
    numHands: 2, // 手ランドマーク検出機能によって検出される手の最大数
    minHandDetectionConfidence: 0.5, // 手の検出が成功と見なされるために必要な、手のひら検出モデルの信頼度の最小スコア -> 手を検出する最初の段階
    minHandPresenceConfidence: 0.5, // 手ランドマーク検出モデルの手の存在スコアの最小信頼度スコア -> 動画／ライブストリームで、追跡（トラッキング）段階に入る前のフィルタリング
    minTrackingConfidence: 0.5, // ハンド トラッキングが成功とみなされるための最小信頼スコア -> 動画／ライブストリームモードで、手を追い続けるトラッキング
  } as const;

  const vision = await FilesetResolver.forVisionTasks(
    PATH.wasm
  );
  let handLandmarker = await HandLandmarker.createFromOptions(vision, optionsHandLandmarker);
  return handLandmarker;
};
